/*
 * @Version: 1.0.0
 * @Description: file content
 * @Autor: enbo.zhou@dsicm.com
 * @Date: 2021-04-06 16:38:56
 * @LastEditors: enbo.zhou@dsicm.com
 * @LastEditTime: 2021-04-13 18:11:26
 * @FilePath: /dsicm-admin-web/src/views/Organization/conmon/departConfig.js
 */
import ChangeRadio from '../components/ChangeRadio'
export default {
  data() {
    return {
      columnsConfig: [
        {
          fixed: 'left',
          type:"selection"
      },
        {
          label: '科室名称',
          prop: 'name',
          align: 'center',
          width:'200px'
        },
        
        {
          label: '所属医院',
          // prop: 'hospitalName',
          align: 'center',
          render: (h, scope) => {
            return (
              <div slot="reference">
               {scope.row.hospitalName ? scope.row.hospitalName : scope.row.platformName }
              </div>
            )
          },
        },
        {
          label: '对应标准科室',
          prop: 'standardDepartmentName',
          align: 'center',
        },
        {
          label: "状态",
          prop: "disabled",
          align: "center",
          width:'100px',
          render: (h, scope) => {
            return (
              <div slot="reference">
               {scope.row.disabled ? '禁用' : '启用' }
              </div>
            )
          },
        },
        {
          label: '修改人ID',
          prop: 'updateUserId',
          align: 'center',
        },
        {
          label: '修改时间',
          prop: 'updateTime',
          align: 'center',
        },
        {
          label: '操作',
          align: 'center',
          width:'250px',
          render: (h, scope) => {
            return (
              <div slot="reference">
                <el-button size="mini" type="text" onClick={() => this.showDetail(scope.row)}> 详情 </el-button>
                <el-button size="mini" type="text" onClick={() => this.goPath(scope.row) }> {scope.row.platformId ? '团队' :'医护'} </el-button>
                {/* this.$router.push({path:'/Organization/medicalinfo',query:{id:scope.row.hospitalId}}) */}
                <el-button size="mini" type="text" onClick={() => this.MoveupHandel(scope)}> 上移 </el-button>
                <el-button size="mini" type="text" onClick={() => this.MovedownHandel(scope)}> 下移 </el-button>
                <el-button size="mini" type="text" onClick={() => this.disabledHandel(scope) }> {scope.row.disabled ? '启用' : '禁用' } </el-button>
                {/* <el-button size="mini" type="text" onClick={() => this.disabledHandel(scope) }> 删除 </el-button> */}
              </div>
            )
          },
        },
      ],
     
    }
  },
}
